import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=0c7e5358"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c7e5358')) {
      api.createRecord('0c7e5358', component.options)
    } else {
      api.reload('0c7e5358', component.options)
    }
    module.hot.accept("./Products.vue?vue&type=template&id=0c7e5358", function () {
      api.rerender('0c7e5358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/Products.vue"
export default component.exports